import { Navigate } from "react-router-dom";
import { StorageEnum } from "../../../../enums/storage.enum";

const LogoutPage = () => {
    const token = localStorage.getItem(StorageEnum.Token);

    if (token) 
        localStorage.clear()
    return <><Navigate to="/auth/login" /></>
    
}

export default LogoutPage;